import { render, staticRenderFns } from "./LoadingLogo.vue?vue&type=template&id=b26b656c&scoped=true&"
import script from "./LoadingLogo.vue?vue&type=script&lang=js&"
export * from "./LoadingLogo.vue?vue&type=script&lang=js&"
import style0 from "./LoadingLogo.vue?vue&type=style&index=0&id=b26b656c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26b656c",
  null
  
)

export default component.exports